function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import { Text } from "../render/Text";
import { p50, p100 } from "../util/Percent";
import { Container } from "./Container";
import * as $array from "../../core/util/Array";
import * as $type from "../../core/util/Type";
/**
 * Creates a label with support for in-line styling and data bindings.
 *
 * @see {@link https://www.amcharts.com/docs/v5/concepts/common-elements/labels/} for more info
 */
export var Label = /*#__PURE__*/function (_Container) {
  _inherits(Label, _Container);
  var _super = _createSuper(Label);
  function Label() {
    var _this;
    _classCallCheck(this, Label);
    _this = _super.apply(this, arguments);
    Object.defineProperty(_assertThisInitialized(_this), "_text", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this), "_textKeys", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: ["text", "fill", "fillOpacity", "textAlign", "fontFamily", "fontSize", "fontStyle", "fontWeight", "fontStyle", "fontVariant", "textDecoration", "shadowColor", "shadowBlur", "shadowOffsetX", "shadowOffsetY", "shadowOpacity",
      // "leading",
      // "letterSpacing",
      "lineHeight", "baselineRatio",
      //"padding",
      // "stroke",
      // "strokeThickness",
      // "trim",
      // "wordWrap",
      "direction", "textBaseline", "oversizedBehavior", "breakWords", "ellipsis", "minScale", "populateText", "role", "ignoreFormatting"]
    });
    return _this;
  }
  /**
   * @ignore Text is not to be used directly
   */
  _createClass(Label, [{
    key: "text",
    get: function get() {
      return this._text;
    }
  }, {
    key: "_afterNew",
    value: function _afterNew() {
      var _this2 = this;
      _get(_getPrototypeOf(Label.prototype), "_afterNew", this).call(this);
      this._makeText();
      $array.each(this._textKeys, function (property) {
        var propValue = _this2.get(property);
        if (propValue != undefined) {
          _this2._text.set(property, propValue);
        }
      });
      if (this.get("html", "") !== "") {
        this._text.set("text", "");
      }
      this.onPrivate("maxWidth", function () {
        _this2._setMaxDimentions();
      });
      this.onPrivate("maxHeight", function () {
        _this2._setMaxDimentions();
      });
    }
  }, {
    key: "_makeText",
    value: function _makeText() {
      this._text = this.children.push(Text.new(this._root, {}));
    }
  }, {
    key: "_updateChildren",
    value: function _updateChildren() {
      var _this3 = this;
      _get(_getPrototypeOf(Label.prototype), "_updateChildren", this).call(this);
      $array.each(this._textKeys, function (property) {
        _this3._text.set(property, _this3.get(property));
      });
      if (this.isDirty("maxWidth")) {
        this._setMaxDimentions();
      }
      if (this.isDirty("maxHeight")) {
        this._setMaxDimentions();
      }
      if (this.isDirty("rotation")) {
        this._setMaxDimentions();
      }
      // Do not show regular text if HTML is used
      if (this.get("html", "") !== "") {
        this._text.set("text", "");
      } else {
        this._text.set("text", this.get("text"));
      }
      if (this.isDirty("textAlign") || this.isDirty("width")) {
        var textAlign = this.get("textAlign");
        var x;
        if (this.get("width") != null) {
          if (textAlign == "right") {
            x = p100;
          } else if (textAlign == "center") {
            x = p50;
          } else {
            x = 0;
          }
        } else {
          if (textAlign == "left" || textAlign == "start") {
            x = this.get("paddingLeft");
          } else if (textAlign == "right" || textAlign == "end") {
            x = -this.get("paddingRight");
          }
        }
        this.text.set("x", x);
      }
    }
  }, {
    key: "_setMaxDimentions",
    value: function _setMaxDimentions() {
      var rotation = this.get("rotation");
      var vertical = rotation == 90 || rotation == 270 || rotation == -90;
      var maxWidth = this.get("maxWidth", this.getPrivate("maxWidth", Infinity));
      if ($type.isNumber(maxWidth)) {
        this.text.set(vertical ? "maxHeight" : "maxWidth", maxWidth - this.get("paddingLeft", 0) - this.get("paddingRight", 0));
      } else {
        this.text.set(vertical ? "maxHeight" : "maxWidth", undefined);
      }
      var maxHeight = this.get("maxHeight", this.getPrivate("maxHeight", Infinity));
      if ($type.isNumber(maxHeight)) {
        this.text.set(vertical ? "maxWidth" : "maxHeight", maxHeight - this.get("paddingTop", 0) - this.get("paddingBottom", 0));
      } else {
        this.text.set(vertical ? "maxWidth" : "maxHeight", undefined);
      }
    }
  }, {
    key: "_setDataItem",
    value: function _setDataItem(dataItem) {
      _get(_getPrototypeOf(Label.prototype), "_setDataItem", this).call(this, dataItem);
      this._markDirtyKey("text");
      if (this.text.get("populateText")) {
        this.text.markDirtyText();
      }
    }
    /**
     * Returns text with populated placeholders and formatting if `populateText` is
     * set to `true`.
     *
     * @return Populated text
     */
  }, {
    key: "getText",
    value: function getText() {
      return this._text._getText();
    }
  }]);
  return Label;
}(Container);
Object.defineProperty(Label, "className", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "Label"
});
Object.defineProperty(Label, "classNames", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: Container.classNames.concat([Label.className])
});